<div class="row mt-2 no-gutters">
  <div *ngIf="accountCategory" class="col-12">
    <!-- <small>
        <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
        /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a>
      </small> -->
    <small *ngIf="accountCategory== 'RENTAL_FLEET'">
      <a [routerLink]="['/rental-fleet']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
    <small *ngIf="accountCategory == 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'">
      <a [routerLink]="['/commercial-fleet']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
    <small *ngIf="accountCategory== 'DEALER'"><a [routerLink]="['/dealer']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
    <small *ngIf="accountType == 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']" class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
  </div>
  <div *ngIf="authService.isDongleProvider()" class="col-12">
    <small>
      <a [routerLink]="['/provider/dashboard']" class="text-secondary">Admin Console </a>
      /<a [routerLink]="['/settings']" class="text-secondary"> Settings</a></small>
  </div>
</div>

<div class="row align-items-center justify-content-center home-container no-gutters">
  <div class="col pl-0 pr-0">
    <div class="row text-center mt-3 no-gutters">
      <div *ngFor="let option of navigationOptions" class="col-6 col-sm-6 col-md-4 col-lg-3 mb-4">
        <img class="img-fluid icon" src="{{option.imageSource}}" alt="{{option.alt}}" data-toggle="modal"
        [attr.data-target]="option.route" data-backdrop="static" data-keyboard="false" /><br>
        <span class="font-nissan-brand-w01-bold font-14">{{option.label}}</span><br>
        <span class="font-nissan-brand-w01-light font-12">{{option.description}}</span>
      </div>
    </div>
  </div>
</div>



<!-- Modal Location Settings -->
<div *ngIf="accountCategory" class="modal fade" id="locationSettings" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <app-location-settings></app-location-settings>
  </div>
</div>

<!-- Modal Company Profile -->
<div class="modal fade" id="companyProfile" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="companyProfileTitle"> Company Profile
        </h5>
        <button id="closeCompanyProfile" type="button"
          (click)="companyProfileView.resetDomainForm();updateAccount=false" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- <div class="modal-body"> -->
      <app-company-profile (updateClickedEmitter)="updateAccountClicked()" (cancelUpdateClickedEmitter)="cancelUpdate()"
        #companyProfileView></app-company-profile>
      <!-- </div> -->
    </div>
  </div>
</div>


<!-- Modal Security Policies -->
<!-- <div class="modal fade" id="securityPolicies" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <app-security-policies></app-security-policies>
    </div>
  </div>
</div> -->

<!-- Modal Account Profile -->
<!-- <div class="modal fade" id="accountProfile" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="accountProfileTitle">Account Profile</h5>
        <button type="button" class="close" (click)="accountProfileView.resetModels()" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-account-profile #accountProfileView></app-account-profile>
      </div>
    </div>
  </div>
</div> -->